export const PRODURL = 'https://dealerwebservice-api.azurewebsites.net/'
export const TestURL = 'https://dealerwebservice-api-dev.azurewebsites.net/'
export const POST_CONTACT_US = 'DealerWebApp/SendContactEmail'
export const GETINVENTORY = '/DealerWebApp/GetInventory'
export const GET_CATEGORY_LIST =
  '/DealerWebApp/GetTierWiseAssetCategorizationSummary'
export const GET_MACHINES_DETAILS =
  'DealerWebApp/GetInventorySummaryById'
export const URL = PRODURL
